import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import { useHistory } from 'react-router';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { TextAreaField } from 'ksnm-common-ui/lib/Form/TextAreaField';

import { RoutePath } from '@components/AppRouter/constants';
import { usePermission } from '@src/utils/hooks/usePermission';
import { reportGroupEditStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupEditStore';

import { NEW_ENTITY_ID } from '../../../../AppRouter/hooks/constants';
import { FormWithActions } from '../../../FormWithActions';

import styles from './Form.module.scss';

export const Form = observer(() => {
  const { isEditMode, isNew } = reportGroupEditStore;

  const { push } = useHistory();

  const cmReportPermission = usePermission('CmReport');

  const {
    input: { value: code },
  } = useField('code');

  const onCreateReport = useCallback(() => {
    push(`${RoutePath.DICTIONARY_REPORT}/${NEW_ENTITY_ID}`, { code });
  }, [code, push]);

  const onGoReports = useCallback(() => {
    push(RoutePath.DICTIONARY_REPORT, { code });
  }, [code, push]);

  const goToReportGroups = useCallback(() => push(RoutePath.DICTIONARY_REPORT_GROUPS), [push]);

  return (
    <FormWithActions
      store={reportGroupEditStore}
      goBackLink={goToReportGroups}
      actions={
        <div className={styles.buttons}>
          <Button onClick={onCreateReport} disabled={isNew || !cmReportPermission.CREATE}>
            Создать отчет
          </Button>
          <Button onClick={onGoReports}>Переход к отчетам</Button>
        </div>
      }
    >
      <>
        <TextField
          name="code"
          label="Код группы отчетности"
          disabled={!isNew}
          size="small"
          groupStyle={!isEditMode}
          required
          maxLength={7}
        />
        <TextField
          name="codeExt"
          label="Внешний код группы отчетности"
          disabled={!isEditMode}
          size="small"
          groupStyle={!isEditMode}
          required
          maxLength={20}
        />
        <TextField
          name="name"
          label="Наименование группы отчетности"
          disabled={!isEditMode}
          size="small"
          groupStyle={!isEditMode}
          required
          maxLength={255}
        />
        <TextAreaField
          name="description"
          label="Описание группы отчетности"
          disabled={!isEditMode}
          size="small"
          groupStyle={!isEditMode}
          maxLength={1000}
        />
      </>
    </FormWithActions>
  );
});
